/**
 * @generated SignedSource<<6f4d3add5c2437080800efc68d1c3856>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SyncServiceTypeEnum = "BQ_CONTACTS" | "BQ_DASHBOARD" | "BQ_FORM_ENTRIES" | "GCP_SEARCH_SYNC" | "HS_CONTACTS" | "HS_CONTACTS_FORM_REPAIR" | "HS_UTK_QUEUE" | "INTEGRATIONS" | "MARKETO_LEADS" | "ZOHO_CONTACTS";
export type SyncServiceInput = {
  clientMutationId?: string | null | undefined;
  forceSync?: boolean | null | undefined;
  type: SyncServiceTypeEnum;
};
export type SyncService_Mutation$variables = {
  input: SyncServiceInput;
};
export type SyncService_Mutation$data = {
  readonly syncService: {
    readonly nextAvailableTime: number | null | undefined;
    readonly nextRelativeAvailableTime: string | null | undefined;
    readonly status: string | null | undefined;
  } | null | undefined;
};
export type SyncService_Mutation = {
  response: SyncService_Mutation$data;
  variables: SyncService_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SyncServicePayload",
    "kind": "LinkedField",
    "name": "syncService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextAvailableTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextRelativeAvailableTime",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SyncService_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SyncService_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a8482e4b5ec4fde96a50294408b3e445",
    "id": null,
    "metadata": {},
    "name": "SyncService_Mutation",
    "operationKind": "mutation",
    "text": "mutation SyncService_Mutation(\n  $input: SyncServiceInput!\n) {\n  syncService(input: $input) {\n    status\n    nextAvailableTime\n    nextRelativeAvailableTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "99b126086690c57bfabf6507e0f4ae65";

export default node;
